import React from 'react';
import Settings from '../components/Settings';

const DEFAULTS = {
  temperature: 0.7,
  maxTokens: 1024,
};

function getConfig() {
  const config = localStorage.getItem('geminiConfig');
  return config ? JSON.parse(config) : DEFAULTS;
}

function setConfig(config) {
  localStorage.setItem('geminiConfig', JSON.stringify(config));
}

const ConfigPage = () => {
  const config = getConfig();
  return (
    <Settings
      initialTemperature={config.temperature}
      initialMaxTokens={config.maxTokens}
      onSave={setConfig}
    />
  );
};

export default ConfigPage; 